module.exports = __webpack_public_path__ + "media/2022/Trib-e49bdd34.png";